// AUTO-GENERATED by scripts/generate-version.js. Do not edit by hand.
export default Object.freeze({
    "version": "v2026-06-11-12-08-00",
    "packageVersion": "0.1.0",
    "commit": "0ca4a07",
    "branch": "deploy/new-customer-install",
    "buildTime": "2026-06-11T16:56:02.036Z"
});
